var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({staticClass:"minus_svg__icon",attrs:{"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M19 12H5","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-dasharray":"14"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }